import { FC } from 'react';

import { COLORS } from '@/shared/constants/colors';
import { ButtonProps } from '@/shared/uikit/Button';

import { ButtonIw } from './ButtonIw';

export const ButtonBlue: FC<ButtonProps> = ({ children, style, ...props }) => {
  const btnStyle = {
    ...style,
    background: COLORS.systemSky200,
    color: COLORS.white,
  };
  return (
    <ButtonIw style={btnStyle} {...props}>
      {children}
    </ButtonIw>
  );
};
